import React from "react";
import { SVG, IconProps } from "../SVG";
export const UnknownCC = (props: IconProps) => (
    <SVG xmlns="http://www.w3.org/2000/svg" viewBox="0 0 26 19" {...props}>
        <g fill="none" fillRule="evenodd" transform="translate(1 1)">
            <rect
                width={24.5}
                height={17.5}
                x={-0.25}
                y={-0.25}
                fill="#FFF"
                stroke="#E7E9EF"
                strokeWidth={0.5}
                rx={2}
            />
            <path fill="#004E8C" d="M0 3h24v3H0z" />
            <rect width={4} height={4} x={18} y={10} fill="#004E8C" rx={1} />
        </g>
    </SVG>
);
UnknownCC.displayName = "UnknownCC";
